@let processes = smartProcesses();
@if (!!processes.length) {
  <div class="process-panel-container" [class.expanded]="isExpanded()">
    <mat-expansion-panel
      (opened)="isExpanded.set(true)"
      (closed)="isExpanded.set(false)"
      [expanded]="true"
      class="process-panel"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="mat-title-small">
          @let incompleteLength = incompleteProcessLength();

          Smart Upload
          @if (incompleteLength) {
            ({{ incompleteProcessLength() }})
          } @else {
            <emperor-icon
              name="check_in_circle"
              class="complete-icon"
            ></emperor-icon>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="process-list">
        @for (process of processes; track process.upload_id) {
          <div class="process-item">
            <span
              class="process-name mat-body-medium"
              [class.processing]="
                process.status !== SmartUploadProcessStatus.Completed &&
                process.status !== SmartUploadProcessStatus.Failed
              "
            >
              @if (
                process.status === SmartUploadProcessStatus.Completed ||
                process.status === SmartUploadProcessStatus.Failed
              ) {
                <emperor-button
                  (click)="removeProcess(process.upload_id)"
                  class="small-button emperor-ui-manually-set-size"
                  [uiButtonType]="EmperorUIButtonTypes.Text"
                  [ariaLabel]="'Remove ' + process.name + ' from list'"
                  title="Remove"
                >
                  <span>
                    <ng-icon
                      class="close-icon"
                      name="matCloseOutline"
                    ></ng-icon>
                  </span>
                </emperor-button>
              }
              <span [title]="process.name">
                {{ process.name }}
              </span>
            </span>
            @if (process.status === SmartUploadProcessStatus.Completed) {
              <div class="actions">
                <emperor-button
                  (click)="navigateToAppForm(process)"
                  [uiButtonType]="EmperorUIButtonTypes.Text"
                  ><span>Review</span></emperor-button
                >
              </div>
            } @else {
              <div class="loading-status">
                @if (process.status !== SmartUploadProcessStatus.Failed) {
                  <emperor-spinner [diameter]="20"></emperor-spinner>
                } @else {
                  <emperor-icon
                    name="interface_alert_circle"
                    class="error-icon"
                  ></emperor-icon>
                }
                <div
                  class="mat-body-small"
                  [class.failed]="
                    process.status === SmartUploadProcessStatus.Failed
                  "
                >
                  {{ process.status }}
                </div>
              </div>
            }
          </div>
        }
      </div>
    </mat-expansion-panel>
  </div>
}
